import { render, staticRenderFns } from "./TotalResult.vue?vue&type=template&id=dd8ac3b6&scoped=true"
import script from "./TotalResult.vue?vue&type=script&lang=js"
export * from "./TotalResult.vue?vue&type=script&lang=js"
import style0 from "./TotalResult.vue?vue&type=style&index=0&id=dd8ac3b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8ac3b6",
  null
  
)

export default component.exports